import { Grid, Stack, Typography } from '@mui/material';
import React from 'react';

const InvoiceTermsWarranty = ({ data = {} }) => {
    return (
        <Grid container item justifyContent={'start'}>
            <Grid item xs={12}>
                <Stack spacing={1}>
                    <Typography fontSize={16} variant="body1" fontWeight={'500'}>
                        Terms and Conditions
                    </Typography>
                    <Typography
                        variant="body1"
                        fontWeight={400}
                        fontSize={16}
                        whiteSpace="pre-line"
                        style={{ color: 'rgba(0, 0, 0, 0.65)', wordBreak: 'break-word' }}
                    >
                        {data?.termsAndWarranty?.title}
                    </Typography>
                    <Typography
                        variant="body1"
                        fontWeight={400}
                        fontSize={16}
                        whiteSpace="pre-line"
                        style={{ color: 'rgba(0, 0, 0, 0.65)', wordBreak: 'break-word' }}
                    >
                        {data?.termsAndWarranty?.description}
                    </Typography>
                </Stack>
            </Grid>
        </Grid>
    );
};

export default InvoiceTermsWarranty;
